// @flow

import { useEffect } from 'react';
import {
  type ConfirmedIncomingPayment,
  type PendingIncomingPayment,
  useIncomingPayment,
  getWaitBeforeRedirect,
  getRedirectUrlAfterPayment,
  getMustRedirectAfterPayment,
  getMustRedirectAfterPaymentConfirmed,
} from '@tectonics/prs/incoming-payment';

export function useAutomaticRedirect() {
  const incomingPayment = useIncomingPayment();

  useEffect(() => {
    let timeoutId;

    if((incomingPayment.status === 'CO' || incomingPayment.status === 'PE') && shouldRedirect(incomingPayment)) {
      timeoutId = setTimeout(() => {
        window.location = getRedirectUrlAfterPayment(incomingPayment);
      }, getWaitBeforeRedirect(incomingPayment) || 0);
    }

    return () => clearTimeout(timeoutId);
  }, [incomingPayment]);
}

function shouldRedirect(incomingPayment: ConfirmedIncomingPayment|PendingIncomingPayment): boolean {
  return getMustRedirectAfterPayment(incomingPayment) || getMustRedirectAfterPaymentConfirmed(incomingPayment);
}
